import useFacilitiesByOrgUnitData from '../../../state/facility/facilityByOrgUnit/UseFacilitiesByOrgUnitData';

const useFacilityCombobox = (orgUnitId) => {
  const { facilityComboboxState, getFacilitiesByOrgUnit } = useFacilitiesByOrgUnitData(orgUnitId);

  return { facilityComboboxState, getFacilitiesByOrgUnit };
};

export default useFacilityCombobox;